<template>
  <div class="articles-by-category p-3">
    <PageTitle :main="category.name" :sub="category.description" />
    <ul>
      <li v-for="article in articles" :key="article.id">
        <ArticleItem
          :article="article"
          :isPublicationDate="true"
          :isViews="true"
        />
      </li>
    </ul>
    <!-- <div class="load-more">
      <button
        v-if="loadMore"
        class="btn btn-lg btn-outline-primary"
        @click="getArticles"
      >
        Carregar mais artigos
      </button>
      <b-button class="btn-lg" v-if="loadMore" @click="getArticles"
        >Carregar mais artigos</b-button
      >
    </div> -->
  </div>
</template>

<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
import PageTitle from "../template/PageTitle.vue";
import ArticleItem from "./ArticleItem.vue";

export default {
  name: "ArticlesByCategory",
  components: { PageTitle, ArticleItem },
  data: function () {
    return {
      category: {},
      articles: [],
      page: 1,
      loadMore: true,
    };
  },
  methods: {
    getCategory() {
      const url = `${baseApiUrl}/api/publico/categorias/${this.category.id}`;
      axios(url).then((res) => (this.category = res.data));
    },
    getArticles() {
      const url = `${baseApiUrl}/api/publico/categorias/${
        this.category.id
      }/artigos?page=${this.page - 1}&size=50`;
      axios(url).then((res) => {
        this.articles = this.articles.concat(res.data.content);
        this.page++;

        if (res.data.length === 0) this.loadMore = false;
      });
    },
  },
  watch: {
    $route(to) {
      this.category.id = to.params.id;
      this.articles = [];
      this.page = 1;
      this.loadMore = true;

      this.getCategory();
      this.getArticles();
    },
  },
  mounted() {
    this.$store.commit("toggleFooter", false);
    // this.$store.commit("toggleIconMenu", true);
    this.category.id = this.$route.params.id;
    this.getCategory();
    this.getArticles();
  },
};
</script>


<style>
.articles-by-category ul {
  list-style-type: none;
  padding: 0px;
}

.articles-by-category .load-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 25px;
}

.load-more button {
  border-color: #ffc107;
  background-color: #ffc107;
  color: #414345;
}
.load-more button:hover {
  color: #ffc107;
}
</style>